import parseCurrency from "./parseCurrency";

const getFieldByKey = (meta, key) => {
    for (const f of meta) {
        if (f.key.trim().toLowerCase() === key.trim().toLowerCase())
            return f;
    }
    return null;
};

export default (meta, key, forceNumber=false) => {
    const results = new Map(); // Keep track of evaluated results.
    const evaluating = new Set();
    
    const evaluate = (key) => {
        const normalizedKey = key.trim().toLowerCase();
        if (evaluating.has(normalizedKey)) return "🚫 ERROR";

        let value = getFieldByKey(meta, key);
        if (!value) return 0;
    
        if (!value.expression)
            return parseCurrency(value.value, forceNumber);
    
        // Check for invalid start to prevent eval errors
        if (value.expression.trim().startsWith('==')) {
            return "🚫 ERROR";
        }
    
        value = value.expression;
        evaluating.add(normalizedKey);

        try {
            const matches = value.match(/{(.*?)}/g);
            if (matches) {
                for (const match of matches) {
                    const rawInner = match.substring(1, match.length - 1);
                    const innerKeyNorm = rawInner.trim().toLowerCase();
                    if (!results.has(innerKeyNorm)) results.set(innerKeyNorm, evaluate(rawInner));
                    value = value.replaceAll(match, results.get(innerKeyNorm));
                }
            }

            // Evaluate the expression safely
            // eslint-disable-next-line
            return eval(value.substring(1));
        } catch (error) {
            console.error("Evaluation error:", error);
            return "🚫 ERROR";
        } finally {
            evaluating.delete(normalizedKey);
        }
    };
    

    // Evaluate this field key
    const tmp = evaluate(key);
    
    if (!forceNumber && typeof tmp === "number") {
        return tmp < 0 ? `(${Math.abs(tmp).toLocaleString('en-US', { style: 'currency', currency: 'USD', minFractionDigits: 2, maxFractionDigits: 2 }).substring(1)})` : tmp.toLocaleString('en-US', { style: 'currency', currency: 'USD', minFractionDigits: 2, maxFractionDigits: 2 }).substring(1);
    }
    return tmp;

}